import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import qs from 'query-string';
import { useLocation, useHistory } from 'react-router-dom';
import { View } from '../../../components/Common/react-native-components';
import PaginationWithNestedGrid from '../component/ExapandableGridWrapper';
import { columns, data, columns2, data2 } from '../constants';
import MultiOptionsCard from '../../../components/Common/Card/MultiOptionsCard';
import MultiFeatureCard from '../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
const InsightsContainer = ({ dispatch, insightsSlice }) => {
  const location = useLocation();
  const history = useHistory();

  const [tableData, setTableData] = useState([]);

  const appliedFilters = useMemo(() => {
    const parsed = qs.parse(location.search);
    return parsed.filters ? JSON.parse(decodeURIComponent(parsed.filters)) : {};
  }, [location.search]);

  //   useEffect(() => {
  //     dispatch(
  //       getInsightsData({
  //         filters: appliedFilters,
  //         onSuccess: data => setTableData(data),
  //         onError: () => setTableData([])
  //       })
  //     );
  //   }, [JSON.stringify(appliedFilters)]);

  return (
    <View style={{ padding: 20, background: '#fff' }}>
      <View>
        <MultiFeatureCard
          title='Revenue Overview'
          subTitle='Last 6 months'
          renderContent={() => <PaginationWithNestedGrid columns={columns} data={data} />}
        />
      </View>

      <View>
        <MultiFeatureCard
          title='Revenue Overview'
          subTitle='Last 6 months'
          renderContent={() => {
            return <PaginationWithNestedGrid columns={columns2} data={data2} />;
          }}
        />
      </View>
    </View>
  );
};

const mapStateToProps = state => ({
  insightsSlice: state.insightsReducer
});

export default connect(mapStateToProps)(InsightsContainer);
